import { AuthGroup, FkAuthLevel, SessionData } from './types';

export default class AuthGroupManager {
	groups: AuthGroup[] = [];
	fkAuthLevel: FkAuthLevel = FkAuthLevel.CLIENT;  // default is lowest perms 

	constructor(sessionData: SessionData) {
		this.fkAuthLevel = sessionData.fkAuthLevel;
		this.groups = sessionData.groups;
	}

	canRead(groupName: string): boolean {
		if (!this.hasGroup(groupName)) {
			return false;
		}
		let canRead = false;

		Object.values(this.groups).forEach((group: AuthGroup) => {
			if (group.fkGroupName === groupName) {
				canRead = group.canRead;
			}
		});

		return canRead;
	}

	canWrite(groupName: string): boolean {
		if (!this.hasGroup(groupName)) {
			return false;
		}
		let canWrite = false;

		Object.values(this.groups).forEach((group: AuthGroup) => {
			if (group.fkGroupName === groupName) {
				canWrite = group.canWrite;
			}
		});

		return canWrite;
	}

	hasGroup(groupName: string): boolean {
		let value = false;

		Object.values(this.groups).forEach((group: AuthGroup) => {
			if (group.fkGroupName === groupName) {
				value = true;
			}
		});

		return value;
	}

	getAuthLevel(): FkAuthLevel {
		return this.fkAuthLevel;
	}

	isRoot(): boolean {
		return this.fkAuthLevel === FkAuthLevel.ROOT;
	}

	isInternal(): boolean {
		return this.fkAuthLevel === FkAuthLevel.FIRSTROI;
	}

	isExternal(): boolean {
		return this.fkAuthLevel === FkAuthLevel.CLIENT;
	}
}